











import { Component, Vue } from 'vue-property-decorator';
import Message from '@/common/components/Message.vue';
import Loader from '@/common/components/Loader.vue';
import { UserService, ConfirmationParamsInterface, SuccessResponseBodyInterface } from '@/common/services/user.service';
import { ErrorInterface } from '@/common/helpers/error.helper';
import { prepareRequestParams } from '@/common/helpers/prepare-request-data.helper';
import APP_CONFIG from '../config';
import { getText } from '@/common/locales';
import { GM_ERROR_CODES } from '@/common/constants/gm-error-codes';

@Component({
    components: {
        Message,
        Loader,
    },
})
export default class AccountActivation extends Vue {
    public messageTitle = '';
    public messageDescription = '';
    public isLoading = true;

    public mounted(): void {
        UserService.confirmRegistration(this.confirmRegistrationParams)
            .then(this.confirmRegistrationSuccess)
            .catch(this.confirmRegistrationError);
    }

    private get confirmRegistrationParams(): ConfirmationParamsInterface {
        const { UAD_PORTAL, BASE_USER_AGENT } = APP_CONFIG;
        const params = {
            verificationCode: this.$route.params.token,
        };

        return prepareRequestParams(params, UAD_PORTAL, BASE_USER_AGENT) as ConfirmationParamsInterface;
    }

    private confirmRegistrationSuccess(response: SuccessResponseBodyInterface): void {
        this.isLoading = false;
        this.messageTitle = getText('components.account_activation.thank_you');
        this.messageDescription = getText('components.account_activation.account_already_active');
    }

    private confirmRegistrationError(error: ErrorInterface): void {
        this.isLoading = false;

        if (error.code === GM_ERROR_CODES.GMU_EMAIL_ALREADY_CONFIRMED) {
            this.messageTitle = getText('components.account_activation.link_has_been_used');
            this.messageDescription = getText('components.account_activation.account_active');

            return;
        }

        this.messageTitle = getText('components.account_activation.link_incorrect');
        this.messageDescription = getText('components.account_activation.try_again');
    }
}
